import React from 'react';
import PropTypes from 'prop-types';
import { TableCell } from 'smartsuite-ui';

function sumOfAllMetrics(sectionValues) {
    return sectionValues.reduce((a, b) => a + b);
}

// eslint-disable-next-line complexity
export default function StackedBar(props) {
    const { comparisonMetricKey, dataColorMappings, resultRow, metricKeys } =
        props;

    const maxComparisonValue = Math.max(
        resultRow[comparisonMetricKey],
        sumOfAllMetrics(metricKeys.map((key) => resultRow[key]))
    );

    function renderSection(metricKey, cellValue, color) {
        const percentage = (cellValue / maxComparisonValue) * 100;
        const widthPercentage = Number.isFinite(percentage)
            ? `${percentage}%`
            : '0%';

        return (
            <div
                title={`${props.legendFormatter(metricKey)}: ${cellValue}`}
                key={metricKey}
                className="stacked-bar__bar"
                style={{
                    backgroundColor: color,
                    width: widthPercentage,
                }}
            />
        );
    }

    return (
        <TableCell cssClassModifiers={['stacked-bar']}>
            {metricKeys.map((metricKey) =>
                renderSection(
                    metricKey,
                    resultRow[metricKey],
                    dataColorMappings[metricKey]
                )
            )}
        </TableCell>
    );
}

StackedBar.propTypes = {
    comparisonMetricKey: PropTypes.string,
    dataColorMappings: PropTypes.instanceOf(Object),
    resultRow: PropTypes.instanceOf(Object),
    metricKeys: PropTypes.instanceOf(Array),
    legendFormatter: PropTypes.func.isRequired,
};

StackedBar.defaultProps = {
    dataColorMappings: {},
};
